/**
 * Fiskal Cloud Admin Archiving Usage API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { AdminArchivingContractBodyDTO } from '../model/models';
import { ArchivingContractCreateBodyDTO } from '../model/models';
import { ArchivingContractDTO } from '../model/models';
import { ArchivingContractStatusChangeDTO } from '../model/models';
import { ArchivingContractsResponseDTO } from '../model/models';
import { ContractLogPeriodEnumDTO } from '../model/models';
import { ContractStatusEnumDTO } from '../model/models';
import { ContractTypeEnumDTO } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface CreateArchivingContractRequestParams {
    archivingContractCreateBodyDTO: ArchivingContractCreateBodyDTO;
}

export class ClsCreateArchivingContractRequestParams {
    archivingContractCreateBodyDTO: ArchivingContractCreateBodyDTO = undefined;
}

export interface DeleteArchivingContractRequestParams {
    archivingContractId: string;
}

export class ClsDeleteArchivingContractRequestParams {
    archivingContractId: string = undefined;
}

export interface GetArchivingContractByCustomerIdentifierRequestParams {
    customerIdentifier: string;
}

export class ClsGetArchivingContractByCustomerIdentifierRequestParams {
    customerIdentifier: string = undefined;
}

export interface GetArchivingContractByIdRequestParams {
    archivingContractId: string;
}

export class ClsGetArchivingContractByIdRequestParams {
    archivingContractId: string = undefined;
}

export interface GetArchivingContractsRequestParams {
    contractLogPeriod?: Array<ContractLogPeriodEnumDTO>;
    projectNumber?: string;
    filter?: string;
    search?: string;
    status?: Array<ContractStatusEnumDTO>;
    contractMonth?: string;
    customerName?: string;
    customerIdentifier?: string;
    contractType?: Array<ContractTypeEnumDTO>;
    contractIds?: Array<string>;
    pageSize?: number;
    pageNumber?: number;
    sort?: string;
}

export class ClsGetArchivingContractsRequestParams {
    contractLogPeriod?: Array<ContractLogPeriodEnumDTO> = undefined;
    projectNumber?: string = undefined;
    filter?: string = undefined;
    search?: string = undefined;
    status?: Array<ContractStatusEnumDTO> = undefined;
    contractMonth?: string = undefined;
    customerName?: string = undefined;
    customerIdentifier?: string = undefined;
    contractType?: Array<ContractTypeEnumDTO> = undefined;
    contractIds?: Array<string> = undefined;
    pageSize?: number = undefined;
    pageNumber?: number = undefined;
    sort?: string = undefined;
}

export interface UpdateArchivingContractRequestParams {
    archivingContractId: string;
    ifMatch: string;
    adminArchivingContractBodyDTO: AdminArchivingContractBodyDTO;
}

export class ClsUpdateArchivingContractRequestParams {
    archivingContractId: string = undefined;
    ifMatch: string = undefined;
    adminArchivingContractBodyDTO: AdminArchivingContractBodyDTO = undefined;
}

export interface UpdateArchivingContractStatusRequestParams {
    archivingContractId: string;
    ifMatch: string;
    archivingContractStatusChangeDTO: ArchivingContractStatusChangeDTO;
}

export class ClsUpdateArchivingContractStatusRequestParams {
    archivingContractId: string = undefined;
    ifMatch: string = undefined;
    archivingContractStatusChangeDTO: ArchivingContractStatusChangeDTO = undefined;
}


export interface AdminContractsApiClientInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Create a new archiving contract
     * Create a new archiving contract
* @param requestParameters
     */
    createArchivingContract(requestParameters: CreateArchivingContractRequestParams, extraHttpRequestParams?: any): Observable<ArchivingContractDTO>;

    /**
     * Delete an archiving contract
     * Delete an existing archiving contract.
* @param requestParameters
     */
    deleteArchivingContract(requestParameters: DeleteArchivingContractRequestParams, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * Get an archiving contract detail
     * Get an archiving contract detail for the specified customer identifier.
* @param requestParameters
     */
    getArchivingContractByCustomerIdentifier(requestParameters: GetArchivingContractByCustomerIdentifierRequestParams, extraHttpRequestParams?: any): Observable<ArchivingContractsResponseDTO>;

    /**
     * Get an archiving contract detail
     * Get an archiving contract detail for the specified UUID.
* @param requestParameters
     */
    getArchivingContractById(requestParameters: GetArchivingContractByIdRequestParams, extraHttpRequestParams?: any): Observable<ArchivingContractDTO>;

    /**
     * Get all archiving contracts
     * Get all archiving contracts or filter by specified criteria.
* @param requestParameters
     */
    getArchivingContracts(requestParameters: GetArchivingContractsRequestParams, extraHttpRequestParams?: any): Observable<ArchivingContractsResponseDTO>;

    /**
     * Update an archiving contract
     * Update an archiving contract information. It\&#39;s possible to set a date when the change takes effect.
* @param requestParameters
     */
    updateArchivingContract(requestParameters: UpdateArchivingContractRequestParams, extraHttpRequestParams?: any): Observable<ArchivingContractDTO>;

    /**
     * Update an archiving contract status
     * Update an archiving contract status.
* @param requestParameters
     */
    updateArchivingContractStatus(requestParameters: UpdateArchivingContractStatusRequestParams, extraHttpRequestParams?: any): Observable<ArchivingContractDTO>;

}
